import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Trust from "./sections/Trust";
import Faq from "./sections/Faq";
import Services from "./sections/Services";
import Quoterequestcta from "./sections/Quoterequestcta";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <Hero />
      <Trust />
      <Faq />
      <Services />
      <Quoterequestcta />
      <Footer />
    </div>;
}